import React, { useState, useEffect, useRef } from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    CircularProgress,
    Accordion
} from '@material-ui/core';

import {
    Insert as AddCreditRequest,
    SelectALL as SelectCreditRequests,
    Update as UpdateCreditRequest,
    ActiveORDeActive as ActiveOrDeActiveCreditRequests
} from 'Components/Api/CreditRequestAPI';

import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import { logout } from 'Components/Helper/Helpers';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import {
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import { SelectDownlinForFundTransfer as USER_SELECT_DOWNLINE_FOR_FUND_TRANSFER } from 'Components/Api/UsersApi';
import { FETCH_LIST } from 'Config';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const CreditRequestSetting = () => {
    const formRef = useRef();
    const classes = commonStyle();

    const [tableItems, setTableItems] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [IsFetchAllList, setisFetchAllList] = useState(false);
    const [openFilter, setOpenFilter] = useState(true);
    const [TakeCount, setTakeCount] = useState(100);

    const [downline, setDownline] = useState([]);


    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select User'
    });
    const [ModelObj] = useState({
        User: userDefault,
        Amount: 0
    });


    const isValidToRefreshList = (list) => {
        if (IsFetchAllList === false) {
            return true;
        }

        if (list === undefined || list === null) {
            return true;
        }

        if (list.length <= 1) {
            return true;
        }

        return false;
    };
    const fetchUserList = async () => {
        let listValue = await FETCH_LIST();

        if (listValue === undefined || listValue === null || listValue === '') {
            return;
        }

        if (listValue === 'All') {
            setisFetchAllList(true);
            selectDownline('');
            return;
        }
    };
    const selectDownline = async (values) => {
        if (IsFetchAllList === true) {
            values = '';
        }

        var jsonObj = {
            FirmName: values
        };

        if (isValidToRefreshList(downline) === false) {
            return;
        }

        setLoading(true);
        var request = JSON.stringify(jsonObj);
        setLoading(false);
        const response = await USER_SELECT_DOWNLINE_FOR_FUND_TRANSFER(request);
        if (!response.isAuthorized) logout();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [userDefault, ...data];

        setDownline(objWithSelectAll);
    };
    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        selectDownline(text);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);

        let request = {
            UserID: values.User.UserID,
        };

        let requestJSON = JSON.stringify(request);

        const {
            data,
            status,
            isAuthorized
        } = await AddCreditRequest(requestJSON);

        setLoading(false);
        if (!isAuthorized) logout();
        if (!status) {
            setIsError(true);
            setResponseMessage(data);
            setSeverity('error');
            return;
        }

        setIsError(true);
        setResponseMessage(data);
        setSeverity('success');
        resetForm();

        // Refresh the table data
        SelectData();
    };

    const validationSchema = Yup.object({
        User: Yup.object()
            .nullable(PLEASE_SELECT_VALID + ' User')
            .required(PLEASE_SELECT_VALID + ' User')
            .shape({
                UserID: Yup.string()
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'User')
                    .required(PLEASE_SELECT_VALID + 'User')
            }),
    });

    const SelectData = async () => {
        setLoading(true);
        setTableItems([]);
        setLoading(false);
        const response = await SelectCreditRequests();

        if (!response.isAuthorized) logout();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(response.data);
        setTableItems(data);
    };

    const handleActiveAll = async (isActive) => {
        setLoading(true);

        let request = {
            IsActive: isActive
        };

        let requestJSON = JSON.stringify(request);

        const {
            data,
            status,
            isAuthorized
        } = await ActiveOrDeActiveCreditRequests(requestJSON);

        setLoading(false);
        if (!isAuthorized) logout();
        if (!status) {
            setIsError(true);
            setResponseMessage(data);
            setSeverity('error');
            return;
        }

        setIsError(true);
        setResponseMessage(data);
        setSeverity('success');

        SelectData();
    };

    useEffect(() => {
        SelectData();
        fetchUserList();
        createColumns();
    }, []);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'CreditRequestID',
            srno: true
        });
        columns.push({
            label: 'FirmName',
            name: 'FirmName'
        });
        columns.push({
            label: 'Used Amount',
            name: 'UsedAmount'
        });
        columns.push({
            label: 'Available Amount',
            name: 'AvailableAmount'
        });
        columns.push({
            label: 'Max Limit Amount',
            name: 'MaxLimitAmount',
            textwrapwidth: 100,
            editable: true,
            editableForUpdate: true
        });
        columns.push({
            label: 'IsDisplay',
            name: 'IsDisplay',
            activate: true,
            primaryKeyIndex: 0,
            callback: (id, value) => {

            }

        });
        columns.push({
            label: 'IsActive',
            name: 'IsActive',
            activate: true,
            primaryKeyIndex: 0,
            callback: (id, value) => {

            }

        });

        columns.push({
            label: 'UserID',
            name: 'UserID',
            hide: true
        });

        columns.push({
            label: 'Update',
            name: 'CreditRequestID',
            save: true,
            buttonTitle: 'Update',
            callback: (value) => {
                UpdateSettings(value);
            }
        });

        setMainColumns(columns);
    };

    const UpdateSettings = async (value) => {
        let jsonObj = {
            CreditRequestID: value[0],
            MaxLimitAmount: value[4],
            IsDisplay: value[5],
            IsActive: value[6],
            UserID: value[7],
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoading(true);
        const { isAuthorized, status, data } = await UpdateCreditRequest(request);
        setLoading(false);

        if (!isAuthorized) logout();

        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);
            return;
        }

        setSeverity('success');
        setResponseMessage(data);
        setIsError(true);

        SelectData();
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                innerRef={formRef}
                initialValues={ModelObj}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                resetForm={ModelObj}
            >
                {({ setFieldValue, handleSubmit, values, errors, touched }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <CustomAccordion
                                    title={'Credit Request Setting'}
                                    open={openFilter}
                                    setOpen={(value) => setOpenFilter(value)}
                                >
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Field
                                                component={AsyncAutoComplete}
                                                defaultValue={userDefault}
                                                FieldName="User"
                                                name="User"
                                                SubFieldName="UserID"
                                                options={downline}
                                                getOptionLabel={(option) =>
                                                    option.FirmName
                                                }
                                                textFieldProps={{
                                                    label: 'Select User'
                                                }}
                                                onSearchCallback={(text) => {
                                                    callSearch(text);
                                                }}
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    setUserDefault({
                                                        UserID: value.UserID,
                                                        FirmName: value.FirmName
                                                    });
                                                }}
                                            />
                                            {errors.User && touched.User && (
                                                <div className={classes.errorText}>{errors.User}</div>
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Add Credit Request"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loading}
                                            >
                                                Add Credit Request
                                            </PrimaryButton>
                                            {loading && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>

                                        <Grid
                                            container
                                            spacing={2}
                                            style={{ marginTop: '10px', paddingLeft: '10px' }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={2}
                                                lg={2}
                                            >
                                                <PrimaryButton
                                                    onClick={() => handleActiveAll(true)}
                                                    title="Activate All"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                    style={{ backgroundColor: '#4caf50' }}
                                                >
                                                    Activate All
                                                </PrimaryButton>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={2}
                                                lg={2}
                                            >
                                                <PrimaryButton
                                                    onClick={() => handleActiveAll(false)}
                                                    title="Deactivate All"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                    style={{ backgroundColor: '#f44336' }}
                                                >
                                                    Deactivate All
                                                </PrimaryButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CustomAccordion>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <ReactTable
                data={tableItems}
                columns={mainColumns}
                count={10}
                rowsPerPage={TakeCount}
                serverSide={true}

            />
        </CustomContainer>
    );
};